import LegalPageLayout from "@/components/LegalPageLayout";
import TermsOfServiceContent from "@/components/legal/TermsOfServiceContent";
import { legalDocumentById } from "@/utils/legalDocs";

const DOC = legalDocumentById("terms");

export default function TermsOfServicePage() {
  return (
    <LegalPageLayout title={DOC.title} lastUpdated={DOC.lastUpdated}>
      <TermsOfServiceContent />
    </LegalPageLayout>
  );
}
